import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Button, Input, List, Avatar } from "antd";
import UserLogin from "./forms/UserLogin";
import { PersonLinesFill, HouseFill, FilePostFill, Activity, Globe2, SaveFill } from 'react-bootstrap-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;

var HomeContent = function HomeContent() {
  var data = [{
    title: 'Gerez vos compte client',
    avatar: /*#__PURE__*/_jsx(HouseFill, {
      size: 30
    }),
    description: "Retrouvez l'etats de vos comptes clients avec facilité"
  }, {
    title: 'Gérer les dossiers patients',
    avatar: /*#__PURE__*/_jsx(PersonLinesFill, {
      size: 30
    }),
    description: "Afficher le dossier medical de n'importe quel client"
  }, {
    title: 'Visualiser les dossiers médicaux',
    avatar: /*#__PURE__*/_jsx(FilePostFill, {
      size: 30
    }),
    description: "Visionner avec confort le dossier patients"
  }, {
    title: "Enregistrez vos consultations",
    avatar: /*#__PURE__*/_jsx(Activity, {
      size: 30
    }),
    description: "Enregistrer toutes les consultations sur un patient"
  }, {
    title: "Stoquez les resultats d'analyses",
    avatar: /*#__PURE__*/_jsx(SaveFill, {
      size: 30
    }),
    description: "Gardez les resultats d'analyse patient et affichez au besoin"
  }, {
    title: "Pourtout ou vous vous trouvez",
    avatar: /*#__PURE__*/_jsx(Globe2, {
      size: 30
    }),
    description: "Le tout accessible en un clique, ou que vous soyez"
  }];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "login-page-container",
      children: /*#__PURE__*/_jsx(Container, {
        fluid: true,
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: {
              span: 6
            },
            md: {
              span: 6
            },
            sm: 6,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                padding: '0px 82px'
              },
              children: /*#__PURE__*/_jsxs("div", {
                className: "home-right-box",
                children: [/*#__PURE__*/_jsx("img", {
                  src: "drawables/mvl.png",
                  style: {
                    width: '170px'
                  }
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h3", {
                  style: {
                    fontWeight: 'bold'
                  },
                  children: "Gestion de dossiers patients"
                }), /*#__PURE__*/_jsx(UserLogin, {}), /*#__PURE__*/_jsx("div", {
                  className: "hlogo"
                })]
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: {
              span: 6
            },
            md: {
              span: 6
            },
            sm: 6,
            style: {
              backgroundImage: 'url(drawables/homeimg.png)',
              backgroundSize: '70%',
              backgroundColor: '#198794'
            },
            children: /*#__PURE__*/_jsx("div", {})
          })]
        })
      })
    }), /*#__PURE__*/_jsx("br", {})]
  });
};

export default HomeContent;